import { functionsJson } from "@corca/data";

import { prioritizeSuggestionRules } from "@/input/utils/editOperators";

import { appendLatexKeywords } from "./utils/appendLatexKeywords";
import { filterSuggestions } from "./utils/filterSuggestions";
import { normalizeSuggestionKeywords } from "./utils/normalizeKeywords";

import type {
  SingleSuggestion,
  SuggestionItem,
  SuggestionProvider,
} from "@/components/suggestions/types";

export const serviceFunctions: SingleSuggestion<"function">[] = functionsJson
  .filter((s) => s.props.isBuiltIn && s.scope?.includes("service"))
  .map(
    (s) =>
      ({
        type: "single",
        item: {
          ...s,
          type: "function",
          keywords: appendLatexKeywords(s.key, normalizeSuggestionKeywords(s)),
          intlName: "function",
          displayName: s.name,
          props: {
            ...s.props,
            arguments: s.props.arguments ?? [{}],
          } as SuggestionItem<"function">["props"],
          labels: s.labels,
          symbolProps: s.symbolProps,
        },
        priority: s.priority ?? 1,
        substitution: s.substitution,
      }) as const,
  );

export const serviceFunctionSuggestionsProvider: SuggestionProvider = {
  type: "serviceFunction",
  omitByDefault: true,
  search: (input, doc, lang) => {
    if (doc.libraries.serves("functions.json")) return [];

    const filteredSuggestions = filterSuggestions(input, serviceFunctions, { lang });

    return [
      filteredSuggestions.map((suggestion) => {
        const priority = prioritizeSuggestionRules(suggestion, doc.cursor);
        return { ...suggestion, priority };
      }),
    ];
  },
};
